import { object, string } from 'yup';

import { getMaxLengthErrMsg, validationErrMessages } from '@constants/validationConstants';
import { MAX_50_LENGTH, MAX_DESCRIPTION_LENGTH } from '@constants/validationMessages';

export const validationSchema = object({
	name: string()
		.max(MAX_50_LENGTH, getMaxLengthErrMsg('Polygon Name', MAX_50_LENGTH))
		.required(validationErrMessages.polygonName),
	description: string()
		.max(MAX_DESCRIPTION_LENGTH, getMaxLengthErrMsg('Comment', MAX_DESCRIPTION_LENGTH)),
});
